import React, { useState, useEffect,useCallback } from 'react';
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { DialogContentText } from "@mui/material";

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import {url,urlLive} from "../../constant";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs'; 
import 'dayjs/locale/en-gb'; // Import the locale for British English

import { IconButton, Tooltip, FormControl, InputLabel, Select, MenuItem } from "@mui/material"; // Import IconButton, Tooltip
import { Send as SendIcon } from "@mui/icons-material"; // Import Send Icon
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Checkbox from "@mui/material/Checkbox";


function Tables() {
  const logUser = JSON.parse(localStorage.getItem('user'));
  const [selectedTab, setSelectedTab] = useState(0);
  const [errors, setErrors] = useState({ firstName: "" });

  // States for users, loading state, and error handling
  const [users, setUsers] = useState([]);
  const [deleteUserId, setDeleteUserId] = useState(null);
  const [emailSendingStatus, setEmailSendingStatus] = useState({}); // Track email sending status for each user
  
  // Dialog states for delete and edit confirmation
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteCategoryId, setDeleteCategoryId] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editCategoryId, setEditCategoryId] = useState(null);
  const [currentPageIndex, setCurrentPageIndex] = useState(0); // Manage pagination state

  // modal edit form data
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [open, setOpen] = useState(false);
  const [birthDate, setBirthDate] = useState(null);
  const [companyId, setCompanyId] = useState('');
  const [isAdminCompany, setIsAdminCompany] = useState(false);
  const [isAdminPlatform, setIsAdminPlatform] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [activeCompanies, setActiveCompanies] = useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [Active, setActive] = React.useState(true);
  const [editUserId, setEditUserId] = useState("");

  // Add loading states
  const [loading, setLoading] = useState(false);  // For fetching categories
  const [formLoading, setFormLoading] = useState(false);  // For form submission
  
  // Fetch categories when the component mounts
  
  useEffect(() => {
    // getCategories();
    getUsers(); // Call getUsers when component mounts
    getActiveCompaines();
  }, []);


  // Fetch users function
  const getUsers = async() => {
    setLoading(true); // Show loader while fetching data
    // setErrors(null); // Reset error state
    var akLogUser = JSON.parse(localStorage.getItem('user'))
    var formData = new FormData();
    formData.append('log_id', akLogUser.user.IdUser);
    const requestOptions = {
      method: "POST",
      // redirect: "follow",
      body: formData
    };
    await fetch(`${url}auth/getAllUsersWithCompany`, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      if (result.users) {
        setUsers(result.users); // Set users data
      }
      if (result.companies) {
        setCompanies(result.companies); // Set users data
      }
      
    })
    .catch((error) => {
      setErrors("Error fetching users: " + error.message); // Set error message
      console.error("Error fetching users:", error);
    })
    .finally(() => {
      setLoading(false); // Hide loader after fetching
    });
  };


  const getActiveCompaines = () => {

    setIsLoading(true);  // Show loader while fetching data
    const requestOptions = {
      method: "GET",
      redirect: "follow"
    };

    fetch(`${url}auth/get-companies?IsActive=true`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        if (result.companies) {
          setActiveCompanies(result.companies || []);
        }
      })
      .catch((error) => console.error("Error fetching companies:", error))
      .finally(() => {
        setIsLoading(false);  // Hide loader after fetching
      });

  }

  // Send email function
  // const sendEmail = (userEmail) => {
  //   setEmailSendingStatus("loading"); // Set loading state when email is being sent

  //   // Simulate email sending (replace with actual email sending logic)
  //   setTimeout(() => {
  //     // Simulate success or failure randomly
  //     const success = Math.random() > 0.5; // Randomly decide if sending is successful
  //     if (success) {
  //       setEmailSendingStatus("success"); // Set to success if email sent
  //     } else {
  //       setEmailSendingStatus("error"); // Set to error if failed
  //     }

  //     // You can also call an API to send the email, and based on the response set the status.
  //     console.log("Email sent to:", userEmail); // Simulate email sending
  //   }, 2000);
  // };


// Send email function
  const sendEmail = (userId, userEmail) => {
    // Update the sending status for this specific user
    setEmailSendingStatus((prevStatus) => ({
      ...prevStatus,
      [userId]: "loading", // Set this user's email to "loading"
    }));

    // Simulate email sending (replace with actual email sending logic)
    setTimeout(() => {
      // Simulate success or failure randomly
      const success = Math.random() > 0.5; // Randomly decide if sending is successful
      setEmailSendingStatus((prevStatus) => ({
        ...prevStatus,
        [userId]: success ? "success" : "error", // Update the sending status for this user
      }));

      console.log("Email sent to:", userEmail); // Simulate email sending
    }, 5000);
  };


  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };


  // Table columns
  const columns = [
    { Header: "#", accessor: "IdUser" },
    { Header: "Nome", accessor: "first_name" },
    { Header: "Cognome", accessor: "last_name" },
    { Header: "Email", accessor: "email" },
    { Header: "Data di nascita", accessor: "BirthDate" },
    { Header: "Amministratore", accessor: "IsAdminPlatform" },
    { Header: "Azienda", accessor: "CompanyName" },
    { Header: "Utente creazione", accessor: "CreationUser" },
    { Header: "Data creazione", accessor: "CreationDate" },
    { Header: "Status", accessor: "Status" },
    // { Header: "Updated By", accessor: "UpdateUser" },
    // { Header: "Updated Date", accessor: "UpdateDate" },
    { Header: "Actions", accessor: "actions" },
  ];

  const handleEditDialogOpen = (data) => {
    console.log(data);
    
    setEditUserId(data.IdUser);
    setFirstName(data.first_name);
    setLastName(data.last_name);
    setPhone(data.phone);
    setEmail(data.email);
    setBirthDate(dayjs(data.BirthDate));
    setCompanyId(data.IdCompany);
    setIsAdminCompany((data.IsAdminCompany) ? true : false);
    setIsAdminPlatform((data.IsAdminPlatform) ? true : false);
    setActive((data.IsActive) ? true : false);
    // alert(isAdminCompany);
    setOpenEditDialog(true);
  }

  const handleEditDialogClose = () => {
    
    setEditUserId(null);
    setOpenEditDialog(false);
  };

  const handleEditSubmit = () => {
    if(!editUserId){
      return false;
    }
      const formData = new FormData();
      formData.append("first_name", firstName);
      formData.append("last_name", lastName);
      formData.append("phone", phone);
      formData.append("email", email);
      formData.append("phone", phone);
      formData.append("password", password);
      formData.append("password_confirmation", passwordConfirmation);
      formData.append("birth_date",  birthDate ? birthDate.format('YYYY-MM-DD') : '');
      formData.append("company_id", companyId); // Send company ID, if provided
      
      formData.append("is_admin_platform", (isAdminPlatform) ? 1 : 0); // !isAdminPlatform
      formData.append("is_admin_company", (isAdminCompany) ? 1 : 0); //!isAdminCompany
      formData.append("is_active", (Active) ? 1 : 0);

      // Send the data to the backend via fetch
      const requestOptions = {
        method: "POST",    // POST method for submitting data
        body: formData, // Use the formData object as the body of the request
      };

      fetch(`${url}auth/editUser/${editUserId}`, requestOptions)
        .then((response) => response.json()) // Parse the response as JSON
        .then((result) => {
          if (result.message) {
            // On success, handle the result here
            console.log(result.message);
            console.log("User Details:", result.user);
            // Optionally, reset the form or redirect

            getUsers();
            handleEditDialogClose();

            // alert(result.message); // You can show a success alert here
            // window.location.reload();
          } else if (result.error) {
            // Show error message if the backend sends an error
            console.log("Error:", result.error);
            alert(result.error); // Show the backend error message in an alert
          }
        })
        .catch((error) => {
          // Handle any other errors
          console.error("Error during fetch:", error);
          alert("An error occurred while registering. Please try again later.");
        })
        .finally(() => {
          // setOpen(false);
        });

  };

  // Prepare rows for table display
  const rows = users.map((user) => ({
    IdUser: user.IdUser,
    first_name: user.first_name,
    last_name: user.last_name,
    email: user.email,
    // BirthDate: user.BirthDate, // Assuming this field exists in the response
    BirthDate: user.BirthDate ? dayjs(user.BirthDate).format('DD-MM-YYYY') : '' , // Assuming this field exists in the response
    IsAdminPlatform: user.IsAdminPlatform === 1 ? "Admin" : "User",
    CompanyName: user.CompanyName,
    CreationUser: user.CreationUser,
    // CreationDate: formatDate(user.CreationDate), // Format date using utility function
    CreationDate: user.CreationDate ? dayjs(user.CreationDate).format('DD-MM-YYYY') : '', // Format date using utility function
    UpdateUser: user.UpdateUser,
    UpdateDate: formatDate(user.UpdateDate), // Format date using utility function
    Status: (user.IsActive) ? 'Active' : 'In Active',
    actions: (
      <Box sx={{ display: "flex", gap: 1 }}>
        {
          (logUser.user.IsAdminPlatform) ? (
            <div>
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={() => handleEditDialogOpen(user)}
                sx={{
                  fontWeight: "bold",
                  padding: "8px 16px",
                  color: "#fff",
                  // backgroundColor: '#1976d2',
                  backgroundColor: '#183759',
                  '&:hover': {
                    // backgroundColor: '#1565c0',
                    backgroundColor: '#204b80',
                  },
                }}
              >
                {/* Edit */}
                Modifica
              </Button>
                {' '}
              <Button
                variant="contained"
                color="error"
                size="small"
                onClick={() => handleDeleteDialogOpen(user.IdUser)}
                sx={{
                  fontWeight: "bold",
                  padding: "8px 16px",
                  backgroundColor: "#d32f2f",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#c62828" },
                }}
              >
                {/* Delete */}
                Cancella
              </Button>
            </div>
            ) : (<div />)
        }

        {/* Send Email Button */}
        {/* <Tooltip title="Send Email">
          <IconButton
            color={
              emailSendingStatus[user.IdUser] === "loading"
                ? "secondary"
                : emailSendingStatus[user.IdUser] === "success"
                ? "primary"
                : "error"
            }
            onClick={() => sendEmail(user.IdUser, user.email)}
            sx={{ padding: "8px" }}
            disabled={emailSendingStatus[user.IdUser] === "loading"} // Disable button if email is being sent
            size="small" // Standard size for IconButton (small size)
          >
            {emailSendingStatus[user.IdUser] === "loading" ? (
              <CircularProgress size={24} sx={{ color: '#1976d2' }} />
            ) : emailSendingStatus[user.IdUser] === "success" ? (
              <SendIcon />
            ) : (
              <SendIcon />
            )}
          </IconButton>
        </Tooltip> */}

      </Box>
    ),
  }));


  // Open the confirmation dialog for deletion
  const handleDeleteDialogOpen = (userId) => {
    setDeleteUserId(userId);
    setOpenDeleteDialog(true);
  };

  // Close the confirmation dialog without deleting
  const handleDeleteDialogClose = () => {
    setDeleteUserId(null);
    setOpenDeleteDialog(false);
  };

  // Perform the delete action if confirmed
  const handleDeleteConfirm = () => {
    
    setLoading(true); // Show loader while fetching data

    const requestOptions = {
      method: "DELETE",
      redirect: "follow"
    };

    fetch(`${url}auth/deleteUser/${deleteUserId}`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        console.log(result);
        // Refresh the user list after deletion
        setUsers(users.filter(user => user.IdUser !== deleteUserId));
        setOpenDeleteDialog(false);
      })
      .catch((error) => console.error("Error deleting user:", error))
      .finally(() => {
        setLoading(false); // Hide loader after fetching
      });


  };

  const handleCompanyChange = (event) => {
    setCompanyId(event.target.value);
  };

  const handleBirthDateChange = (newValue) => {
    setBirthDate(newValue);
  };
  
  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* Loader Component */}
      <Backdrop open={loading || formLoading} sx={{ color: '#fff', zIndex: 1000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                // bgColor="info"  
                bgColor="#183759"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {/* Register Users */}
                  Elenco utenti
                </MDTypography>
              </MDBox>

              <Box sx={{ width: '100%' }}>
                <Tabs
                  value={selectedTab}
                  onChange={handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="fullWidth"
                  aria-label="basic tabs example"
                >
                  {/* <Tab label="List Register Users" /> */}
                  <Tab label="Elenco utenti registrati" />
                  {/* <Tab label="Add User" /> */}
                </Tabs>

                {selectedTab === 0 && (
                  <MDBox pt={3}>
                    <DataTable
                      table={{ columns, rows }}
                      isSorted={false}
                      entriesPerPage={{defaultValue:10}}
                      showTotalEntries={false}
                      noEndBorder
                      currentPageIndex = {currentPageIndex}
                      setCurrentPageIndex = {setCurrentPageIndex}
                    />
                  </MDBox>
                )}

                {/* {selectedTab === 1 && (
                  <MDBox pt={3} px={2}>
                    <MDTypography variant="h6" mb={3} align="center">
                      Add New Category
                    </MDTypography>
                    <Grid container spacing={2} justifyContent="center">
                      <Grid item xs={12} sm={8} md={6} lg={5}>
                        <MDBox mb={2}>
                          <TextField
                            label="Category Name"
                            variant="outlined"
                            fullWidth
                            value={categoryName}
                            onChange={(e) => setCategoryName(e.target.value)}
                            error={!!errors.name}
                            helperText={errors.name}
                            InputLabelProps={{ shrink: true }}
                            sx={{ '& .MuiInputBase-root': { height: '40px' } }}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} sm={8} md={6} lg={5}>
                        <MDBox mb={2}>
                          <Button
                            onClick={handleSubmit}
                            variant="contained"
                            color="primary"
                            fullWidth
                            sx={{
                              //  py: 1.5,
                               fontSize: '14px',
                               borderRadius: '8px',
                               height: '40px',
                               color: '#ffffff',
                               '&:hover': {
                                 backgroundColor: '#0b5ed7',
                               },
                             }}
                             
                          >
                            Add Category
                          </Button>
                        </MDBox>
                      </Grid>
                    </Grid>
                  </MDBox>
                )} */}
              </Box>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={openDeleteDialog}
        onClose={handleDeleteDialogClose}
        fullWidth
        maxWidth="sm"
      >
        {/* <DialogTitle>Confirm Deletion</DialogTitle>  */}
        <DialogTitle>Conferma l'eliminazione</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {/* Are you sure you want to delete this user? This action cannot be undone. */}
            Sei sicuro di voler eliminare questo utente? Questa azione non può essere annullata.     
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose} color="primary">
            {/* Cancel */}
            Annulla
          </Button>
          <Button onClick={handleDeleteConfirm} color="error">
          Cancella
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Confirmation Dialog */}
       <Dialog
        open={openEditDialog}
        onClose={handleEditDialogClose}
        fullWidth
        maxWidth="sm"
      >
        {/* <DialogTitle>Edit User</DialogTitle> */}
        <DialogTitle>Modifica utente</DialogTitle>
        <DialogContent>
          <TextField
            // label="First Name"
            label="Nome"
            variant="outlined"
            fullWidth
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            error={!!errors.firstName}
            helperText={errors.firstName}
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: 2, mt: 2 }}
          />
          <TextField
            // label="Last Name"
            label="Cognome"
            variant="outlined"
            fullWidth
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            error={!!errors.lastName}
            helperText={errors.lastName}
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: 2, mt: 2 }}
          />
          <TextField
            // label="Phone"
            label="Telefono"
            variant="outlined"
            fullWidth
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            error={!!errors.phone}
            helperText={errors.phone}
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: 2, mt: 2 }}
          />
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!errors.email}
            helperText={errors.email}
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: 2, mt: 2 }}
          />
          <TextField
            type="password"
            label="Password"
            variant="outlined"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={!!errors.password}
            helperText={errors.password}
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: 2, mt: 2 }}
          />
          <TextField
            type="password"
            // label="Confirm Password" 
            label="Conferma password"
            variant="outlined"
            fullWidth
            value={passwordConfirmation}
            onChange={(e) => setPasswordConfirmation(e.target.value)}
            error={!!errors.passwordConfirmation}
            helperText={errors.passwordConfirmation}
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: 2, mt: 2 }}
          />

          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
            <DemoContainer components={['DatePicker']}>
              <DatePicker
                sx={{ width: '100%' }}
                // label="Birth Date"
                label="Data di nascita"
                value={birthDate}
                onChange={handleBirthDateChange}

              />
            </DemoContainer>
          </LocalizationProvider>


          <FormControl style={{marginTop: 25}} fullWidth>
            {/* <InputLabel id="company-select-label">Company</InputLabel> */}
            <InputLabel id="company-select-label">Azienda</InputLabel>

              <Select
                labelId="company-select-label"
                id="company-select"
                value={companyId}
                label="Company"
                onChange={handleCompanyChange}
                style={{ height: 45 }}
                sx={{
                  '& .MuiSelect-icon': {
                    display: 'block !important',  // Force icon to be visible
                    fontSize: '1.6rem !important',  // Adjust the size of the dropdown icon
                  },
                }}
                IconComponent={ArrowDropDownIcon}  // Ensures the dropdown icon is displayed
              >
                {/* <MenuItem disabled>Select Company</MenuItem> */}
                {isLoading ? (
                  <MenuItem disabled>
                    <CircularProgress size={24} sx={{ mr: 1 }} />
                    Loading...
                  </MenuItem>
                ) : activeCompanies.length > 0 ? (
                  activeCompanies.map((comp) => (
                    <MenuItem key={comp.IdCompany} value={comp.IdCompany}>
                      {comp.CompanyName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No companies available</MenuItem>
                )}
              </Select>
          </FormControl>

          <Grid style={{marginTop: 15}} item xs={12} md={6}>
            <MDBox sx={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox
                checked={isAdminCompany}
                onChange={(e) => setIsAdminCompany(e.target.checked)}
                sx={{
                  mr: 1,
                  '&.Mui-checked .MuiSvgIcon-root': {
                    backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e"), linear-gradient(195deg, #344767, #344767)`,
                    borderColor: '#344767',
                  },
                }} // Adds spacing between checkbox and text
              />
              {/* <MDTypography variant="body2">Company Administrator</MDTypography> */}
              <MDTypography variant="body2">Amministratore azienda</MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6}>
            <MDBox sx={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox
                checked={isAdminPlatform}
                onChange={(e) => setIsAdminPlatform(e.target.checked)}
                sx={{
                  mr: 1,
                  '&.Mui-checked .MuiSvgIcon-root': {
                    backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e"), linear-gradient(195deg, #344767, #344767)`,
                    borderColor: '#344767',
                  },
                }} // Adds spacing between checkbox and text
              />
              
              {/* <MDTypography variant="body2">Administrator</MDTypography> */}
              <MDTypography variant="body2">Amministratore</MDTypography>  

            </MDBox>
          </Grid>

          <Grid item xs={12} md={6}>
            <MDBox sx={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox
                checked={Active}
                onChange={(e) => setActive(e.target.checked)}
                sx={{
                  mr: 1,
                  '&.Mui-checked .MuiSvgIcon-root': {
                    backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e"), linear-gradient(195deg, #344767, #344767)`,
                    borderColor: '#344767',
                  },
                }} // Adds spacing between checkbox and text
              />
              {/* <MDTypography variant="body2">Active</MDTypography> */}
              <MDTypography variant="body2">Attivo</MDTypography>
            </MDBox>
          </Grid>          

        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditDialogClose} color="primary">
            {/* Cancel */}
            Annulla
          </Button>
          <Button onClick={handleEditSubmit} color="primary">
            {/* Save */}
            Salva
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
  
}

export default Tables;
